
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/decks",
      function () {
        return require("private-next-pages/search/decks.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/decks"])
      });
    }
  